export default __webpack_public_path__ + "static/media/report.a65ee752.svg";